// extracted by mini-css-extract-plugin
export default {"root":"mimic___styles_root__YJTlH","background":"mimic___styles_background__Wkfj+"};